import { FooterComponent } from '@adminprodigydesign/axis';
import { Component, HostBinding, HostListener } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Router, RouterLinkActive, RouterModule } from '@angular/router';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, FooterComponent, RouterModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  constructor(private router: Router) {}

  title = 'heattech';

  mobileOpen = false;
  mobileServicesOpen = false;
  servicesOpen = false;

  @HostBinding('class.scrolled') scrolled = false;
  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.scrolled = window.pageYOffset > 50;
  }

  private openDropdown: 'heating' | 'plumbing' | 'commercial' | null = null;
  private mobileOpenDropdown: 'heating' | 'plumbing' | 'commercial' | null =
    null;

  footerData: any = {
    contactTitle: 'Need Help?',
    contactSubtitle: "We're available 24/7 for you!",
    contactNumber: 'Call Now',
    buttonLink: 'tel:+447506113669',
    gridColumns: 'grid-cols-3',
    columns: [
      {
        title: 'Support',
        links: [
          { label: 'FAQ', url: '#' },
          { label: 'Help Center', url: '#' },
        ],
      },
      {
        title: 'Company',
        links: [
          { label: 'About Us', url: '#' },
          { label: 'Careers', url: '#' },
        ],
      },
      {
        title: 'Legal',
        links: [
          { label: 'Privacy Policy', url: '#' },
          { label: 'Terms of Use', url: '#' },
        ],
      },
    ],
    socialLinks: [
      { class: 'fab fa-instagram', url: '#' },
      // { class: 'fab fa-facebook', url: '#' },
      // { class: 'fab fa-youtube', url: '#' },
      // { class: 'fab fa-x-twitter', url: '#' },
    ],
  };

  isMobileOpen(name: 'heating' | 'plumbing' | 'commercial'): boolean {
    return this.mobileOpenDropdown === name;
  }

  toggleMobileDropdown(name: 'heating' | 'plumbing' | 'commercial'): void {
    this.mobileOpenDropdown = this.mobileOpenDropdown === name ? null : name;
  }

  toggleMobileNav(): void {
    this.mobileOpen = !this.mobileOpen;

    /* optional: lock scroll behind the panel */
    if (this.mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
      this.mobileServicesOpen = false; // reset sub-menu
    }
  }

  isOpen(name: 'heating' | 'plumbing' | 'commercial'): boolean {
    return this.openDropdown === name;
  }

  setDropdown(
    name: 'heating' | 'plumbing' | 'commercial',
    open: boolean
  ): void {
    this.openDropdown = open ? name : null;
  }

  toggleServices(state: boolean): void {
    console.log('mouseenter / mouseleave fired?', state); // 👈 should log every time
    this.servicesOpen = state;
  }

  callNow(): void {
    // Replace with your real number
    window.location.href = 'tel:+441234567890';
  }

  whatsappNow(): void {
    const phoneNumber = '+447506113669';
    const message = 'Hello, I need help with...';
    const url = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(
      message
    )}`;

    // Open in new tab on desktop but navigate in the same tab on mobile
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    if (isMobile) {
      window.location.href = url;
      return;
    }
    const newWindow = window.open(url, '_blank');
    if (newWindow) {
      newWindow.opener = null; // Prevent the new page from being able to access the opener
    } else {
      console.error('Failed to open WhatsApp link in a new tab');
    }
  }

  bookNow(): void {
    // Example: navigate to a booking page
    this.router.navigateByUrl('/book');
  }
}
